import { useDialog } from 'src/customHooks/useDialog';
import Notification, {
    NotificationType,
} from 'src/components/ui/notification/Notification';
import React, { useEffect, useState } from 'react';
import './modal.scss';

interface IModalProps {
    titleContent?: any;
    bodyContent: any;
    footerContent?: any;
    open?: boolean;
    setOpen?: any;
    notification?: {
        show: boolean;
        handleShow: Function;
        type: NotificationType;
        content: string;
    };
}

const ModalComponent = ({
    titleContent,
    bodyContent,
    footerContent,
    open,
    setOpen,
    notification,
}: IModalProps) => {
    const [modalOpen, setModalOpen] = useState<boolean>(true);
    useEffect(() => {
        if (typeof open !== 'undefined') setModalOpen(open);
    }, [open]);

    const cancelHandler = () => {
        setModalOpen(false);
        if (setOpen) setOpen(false);
    };

    const { dialogRef, closeDialogRef, openDialogRef } = useDialog();

    useEffect(() => {
        const openClose = async () => {
            if (modalOpen) openDialogRef();
            else await closeDialogRef();
        };
        openClose();
    }, [modalOpen]);

    return (
        <dialog ref={dialogRef} className={'c-modal'} aria-hidden={modalOpen}>
            <div
                className='c-modal__wrapper'
                role='dialog'
                aria-labelledby='foo-bar-baz'
            >
                <div className='c-modal__header'>
                    {notification?.show ? (
                        <Notification
                            content={notification.content}
                            type={notification.type}
                            visibility={notification.show}
                            setVisibility={(e) => notification.handleShow(e)}
                        />
                    ) : null}
                    {titleContent ? (
                        <div className='c-modal__title__wrapper'>
                            <h2 className='c-modal__title' id='foo-bar-baz'>
                                {titleContent}
                            </h2>
                        </div>
                    ) : null}

                    <button
                        className='c-modal__close-btn  js-modal-close'
                        type='button'
                        aria-label='Close this dialog window.'
                        onClick={cancelHandler}
                    ></button>
                </div>

                <div className='c-modal__content' role='document'>
                    {bodyContent}
                </div>

                {footerContent ? (
                    <div className='c-modal__footer'>{footerContent}</div>
                ) : null}
            </div>
        </dialog>
    );
};

export default ModalComponent;
